angular.module('caferealtor.offer.list').factory('OfferService', OfferService);

OfferService.$inject = ['$resource'];
function OfferService($resource) {
  const OfferEmailDelivery = $resource(
    '/listing/:listingId/offer/:offerId/delivery',
    { listingId: '@listingId', offerId: '@offerId' },
  );
  const OfferEmailPreview = $resource(
    '/listing/:listingId/offer/:offerId/preview',
    { listingId: '@listingId', offerId: '@offerId' },
  );
  const Offer = $resource('/listing/:listingId/offer/:offerId', {
    listingId: '@listingId',
    offerId: '@offerId',
  });

  const OfferAgents = $resource('/listing/:listingId/offer_agents', {
    listingId: '@listingId',
  });

  const OfferNotificationLog = $resource(
    '/listing/:listingId/offer/:offerId/offer_notification_log',
    {
      listingId: '@listingId',
      offerId: '@offerId',
    },
  );

  // Resource Functions//

  function queryOfferEmailDelivery(listingId, offerId) {
    return OfferEmailDelivery.query({ listingId, offerId }).$promise;
  }

  function getOfferEmailPreview(listingId, offerId) {
    return OfferEmailPreview.get({ listingId, offerId }).$promise;
  }

  function getOffer(listingId, offerId) {
    return Offer.get({ listingId, offerId });
  }

  function getOfferAgents(listingId, sortBy, searchCriteria) {
    return OfferAgents.get({ listingId, sortBy, searchCriteria }).$promise;
  }

  function getOfferNotificationLog(listingId, offerId) {
    return OfferNotificationLog.get({ listingId, offerId }).$promise;
  }

  return {
    queryOfferEmailDelivery,
    getOfferEmailPreview,
    getOffer,
    getOfferAgents,
    getOfferNotificationLog,
  };
}

export {};
